import React, { useEffect, useState } from "react";
import {
  ButtonBase,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  CardContent,
  Card,
  LinearProgress,
  InputAdornment,
  IconButton,
  Button,
  TextField,
  Box,
} from "@material-ui/core";
import { toast } from "material-react-toastify";
import { Delete } from "@material-ui/icons";

import { useMeetingAppContext } from "../../MeetingAppContextDef";
import { useTheme } from "@material-ui/core/styles";
import "../mainViewContainer/style.css";
import { useMeeting } from "@videosdk.live/react-sdk";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
var urlValidator = new RegExp(
  /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
);

const ExternalvideoPlayer = ({ panelHeight }) => {
  const [param, setParam] = useSearchParams();

  const theme = useTheme();

  const [videos, setVideos] = useState([]);
  const { setExternalvideoPlayer, setSideBarMode } = useMeetingAppContext();
  const [url, setUrl] = useState("");
  const mMeeting = useMeeting();

  const getvideos = async () => {
    await axios
      .post("https://nowevents.herokuapp.com/get-video", {
        id: param.get("id"),
      })
      .then((r) => {
        if (r?.data?.user?.length > 0) {
          setVideos(r?.data?.user);
        }else{
          setVideos([]);
        }
      });
  };
  useEffect(() => {
    getvideos();
  }, []);
  const deltevideo = async (id) => {
    await axios
      .post("https://nowevents.herokuapp.com/delete-video", {
        id: id,
      })
      .then((r) => {
        getvideos();
      });
  };
  return (
    <List style={{ padding: 10, overflow: "scroll", height: "90%" }}>
      <p style={{ color: "white" }}>Add video url</p>

      <Card
        variant="outlined"
        style={{ height: "auto", width: "100%", marginBottom: 10 }}
        onClick={() => {
          //   setChangeVisual(i);
        }}
      >
        <CardContent style={{ height: "auto", width: "100%" }}>
          <Box style={{ width: "90%" }}>
            <TextField
              id={"inputJoin"}
              placeholder="Enter video url"
              variant="outlined"
              fullWidth
              value={url}
              onChange={(ev) => {
                setUrl(ev.target.value);
              }}
            />
            <Button
              style={{ marginTop: 10, width: "100%" }}
              color="primary"
              variant="contained"
              onClick={async (e) => {
                if (urlValidator?.test(url)) {
                  await axios.post(
                    "https://nowevents.herokuapp.com/create-video",
                    {
                      meetingId: param.get("id"),
                      videoUrl: url,
                    }
                  );

                  mMeeting?.startVideo({
                    link: url,
                  });
                  setExternalvideoPlayer({
                    started: true,
                    link: url,
                  });
                  setSideBarMode(null);
                  setUrl("");
                  setTimeout(() => {
                    getvideos();
                  }, 1500);
                } else {
                  toast.error("Enter valid video url");
                }
              }}
              id={"set"}
            >
              Add
            </Button>
          </Box>
        </CardContent>
      </Card>

      {videos?.map((i) => {
        return (
          <TextField
            id={"inputJoin"}
            style={{
              marginBottom: 10,
            }}
            // placeholder="Enter video url"
            variant="outlined"
            fullWidth
            disabled
            value={i?.videoUrl}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    //   disabled={name.length <= 3}
                    color="primary"
                    variant="contained"
                    //   onClick={startMeeting}
                    // onClick={onClick}

                    id={"btnJoin"}
                    onClick={() => {
                      mMeeting?.startVideo({
                        link: i?.videoUrl,
                      });
                      setExternalvideoPlayer({
                        started: true,
                        link: i?.videoUrl,
                      });
                      setSideBarMode(null);
                    }}
                  >
                    Play
                  </Button>

                  <IconButton onClick={()=>{
                    deltevideo(i?._id)
                    // console.log(i?._id)
                  }}>
                    <Delete
                      style={{
                        color: theme.palette.primary.contrastText,
                      }}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        );
      })}
    </List>
  );
};

export default ExternalvideoPlayer;
